import dom from '../../../helpers/dom';

const skipLink = () => {
  const linkClass = 'skip-link';
  const mainContentId = 'skip-main-content';

  const handleSkipLinkClick = (event) => {
    const mainContent = document.getElementById(mainContentId);
    if (mainContent) {
      event.preventDefault();
      mainContent.focus();
    }
  };

  const init = () => {
    dom.getByClassName(linkClass).forEach((skipLinkElement) => {
      skipLinkElement.addEventListener('click', handleSkipLinkClick);
    });
  };

  return {
    init,
  };
};

export default skipLink();
